import { Handle, Position } from '@xyflow/react'
import TypeBadge from './TypeBadge'

const MAX_TITLE_LEN = 40

function truncateTitle(title) {
  if (!title) return ''
  return title.length > MAX_TITLE_LEN
    ? title.slice(0, MAX_TITLE_LEN) + '...'
    : title
}

/**
 * Custom React Flow node for a memory.
 *
 * data props:
 *   title       — string
 *   memory_type — string
 *   isRoot      — boolean: true for the seed memory
 *   onClick     — () => void: navigate to this memory's graph
 */
export default function MemoryNode({ data }) {
  const { title, memory_type, isRoot, onClick } = data
  const displayTitle = truncateTitle(title)

  return (
    <div
      data-testid="memory-node"
      onClick={onClick}
      className={[
        'w-[200px] min-h-[60px]',
        'px-3 py-2 rounded-lg border font-mono text-xs cursor-pointer transition-colors',
        'bg-zinc-800 text-zinc-100',
        isRoot
          ? 'border-emerald-600 ring-1 ring-emerald-600/40'
          : 'border-zinc-600 hover:border-zinc-400 hover:bg-zinc-700',
      ].join(' ')}
    >
      <Handle type="target" position={Position.Left} className="memory-node-handle" />
      <div className="space-y-1">
        <p
          data-testid="memory-node-title"
          className="text-[11px] font-mono text-zinc-100 leading-tight"
          title={title}
        >
          {displayTitle}
        </p>
        <TypeBadge type={memory_type} />
      </div>
      <Handle type="source" position={Position.Right} className="memory-node-handle" />
    </div>
  )
}
